import Container from '@app/components/Container';
import { ClientError } from '@app/pageComponents/ClientErrorPage';
import { NextSeo } from 'next-seo';
import { LayoutEnum } from '@app/types';
import { compose } from '@app/helpers/compose';
import { withLayout } from '@app/hoc/withLayout';

const ClientErrorPage = () => {
  return (
    <>
      <NextSeo title="404" />
      <Container>
        <ClientError />
      </Container>
    </>
  );
};

export default compose(withLayout(LayoutEnum.Main))(ClientErrorPage);
